// extracted by mini-css-extract-plugin
module.exports = {"pt-system-user-detail":"pt-system-user-detail-d080135889f2f15372cfc33897164248"};